import { render } from "./InstantServiceCard.vue?vue&type=template&id=1be13a73&scoped=true"
import script from "./InstantServiceCard.vue?vue&type=script&lang=js"
export * from "./InstantServiceCard.vue?vue&type=script&lang=js"

import "./InstantServiceCard.vue?vue&type=style&index=0&id=1be13a73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be13a73"]])

export default __exports__